import Layout from '@/layout';
// 通讯录
export default {
    path: '/mailList',
    edirect: '/mailList/index',
    component: Layout,
    meta: {
        modules: [19000]
    },
    children: [
        {
            path: 'index',
            name: 'MailListIndex',
            component: () => import('@/views/mailList/index'),
            meta: {
                title: '通讯录',
                icon: 'menu_txl',
                modules: [19000]
            }
        }
    ]
};
